// extracted by mini-css-extract-plugin
export var pillWrapper = "_qm-0";
export var showOverflow = "_qm-1";